module.exports = __webpack_public_path__ + "img/中繼站2_檸檬.f61026d8.png";